module.exports = __webpack_public_path__ + "img/growcify-website-1-banner.f189b4b5.png";